export default __webpack_public_path__ + "static/media/pic5.00ffb2e6.jpg";